/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    bool, string, func, object, number, shape, arrayOf,
} from 'prop-types';

import mbpLogger from '@module-logger/mbp';
import mbpUtil from '@api-util/mbp';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

import Cookies from 'universal-cookie';
import { applePayDateConverter } from '../../../helpers/applePayShippingOptionsConverter';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import {
    getApplePayStatus,
    getTotalItemInCart,
    // getAppliedPromotions,
    getPassportSubscriptionStatus,
} from '../../../../state/ducks/Common/Common-Selectors';
import { checkApplePayEnabled } from '../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Actions';
import { deleteItem } from '../../../../state/ducks/Cart/ducks/DeleteItem/DeleteItem-Actions';
import { loadCart, getCart } from '../../../../state/ducks/Cart/Cart-Actions';
import { loadOrderId } from '../../../../state/ducks/Order/Order-Actions';
import { getEnterpriseId } from '../../../../state/ducks/Member/ducks/EnterpriseId/EnterpriseId-Selectors';
import { applePayOrderSuccess } from '../../../../state/ducks/Payment/Payment-Actions';

import { withAuth } from '../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getUserSubmittedProductFilterZipcode } from '../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import getPriceFromEngine from '../../../../apis/product-apis/priceEngine';
import cartServices from '../../../../apis/cart-service-apis/cartServices';
import { getIsAuthenticatedStatus, getIsPassportUserLoggedIn } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getSetDataWithTTL } from '../../../../localStorage';
import { getAnalyticsStorageData } from '../../../helpers/tracking/session/sessionTrackingHelpers';

class GraphqlApplePay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartEmpty: false,
        };
        // The following variables are not state variables because assignment to them has to be syncronous
        // and their modification should not trigger a rerender of the component.
        this.price = '';
        this.shipping = '';
        this.service = '';
        this.detailedShipping = {};
        this.tax = '';
        this.total = 0;
        this.orderItemId = '';
        this.cartId = '';
        this.cartData = {};
        this.applePayResponse = {};
        this.shortMonthName = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
    }

    componentDidMount() {
        const {
            callTrackEvent, noOfItemsInCart, checkApplePay, enterpriseId, flags,
        } = this.props;

        if (noOfItemsInCart === 0 && (typeof window !== 'undefined' && !window.location.host.includes('localhost'))) {
            this.setState({
                cartEmpty: true,
            }, () => {
                checkApplePay();
                if ((flags?.shippingDynamicPricingTest || this.dynamicPriceTest()) && enterpriseId) {
                    this.getDynamicPrice();
                }
            });
        }

        callTrackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Feature Impression',
            eventLabel: 'Apple Pay on PDP',
        });
    }

    componentDidUpdate(prevProps) {
        const {
            applePayEnabled, flags, selectedSku: { id }, enterpriseId,
        } = this.props;
        if ((prevProps.selectedSku.id !== id || enterpriseId !== prevProps.enterpriseId || prevProps.applePayEnabled !== applePayEnabled || prevProps.flags?.dynamicPricingTest !== flags?.dynamicPricingTest || prevProps.flags?.shippingDynamicPricingTest !== flags?.shippingDynamicPricingTest)
            && applePayEnabled
            && (this.dynamicPriceTest() || flags?.shippingDynamicPricingTest)
            && enterpriseId) {
            this.getDynamicPrice();
        }
    }

    addApplePayArButtonListener = (event) => {
        if (event?.data?.name === '_apple_ar_quicklook_button_tapped') {
            this.handlePDPButtonClick();
        }
    }

    dynamicPriceTest = () => {
        const { featureFlags, flags } = this.props;
        const pricingTestTTL = featureFlags?.['when-pricing-test-expired'] || 0;
        let dynamicPrice;
        if (pricingTestTTL > 0) {
            dynamicPrice = getSetDataWithTTL('pricing_test_exp', flags?.dynamicPricingTest, pricingTestTTL);
        } else {
            dynamicPrice = flags?.dynamicPricingTest;
        }
        // if Control, considering it null so we won't fire any call
        if (dynamicPrice?.toLowerCase?.() !== 'control') {
            return dynamicPrice;
        }
        return null;
    }

    getLineItem = (name, value) => {
        const lineItem = {};
        lineItem.label = name;
        lineItem.amount = value;
        return lineItem;
    };

    getDetailShippingCharges = () => {
        const detailShippingCharges = this.detailedShipping;

        let serviceCharge = Number(detailShippingCharges.serviceCharge?.serviceChargesWithoutRegulatoryFee) || 0;
        serviceCharge = parseFloat(serviceCharge).toFixed(2);
        let shippingCharge = Number(detailShippingCharges.shippingCharge?.shippingChargesWithoutRegulatoryFee) || 0;
        shippingCharge = parseFloat(shippingCharge).toFixed(2);

        return {
            serviceCharge,
            shippingCharge,
        };
    }

    getLineItems = () => {
        const { featureFlags } = this.props;

        // Delivery extra fees charges
        const stateDeliveryFeeEnabled = featureFlags['is-state-delivery-fee-enabled'] || false;
        const isDetailShippingEnabled = featureFlags['is-detailed-shipping-enabled'] || false;

        const shippingServiceCharges = this.getDetailShippingCharges();
        const lineItems = [
            this.getLineItem('Item Price', typeof this.price === 'number' ? this.price.toFixed(2) : this.price),
        ];

        if (parseFloat(shippingServiceCharges.shippingCharge) > 0) {
            lineItems.push(this.getLineItem('Shipping', parseFloat(shippingServiceCharges.shippingCharge).toFixed(2)));
        }

        if (parseFloat(shippingServiceCharges.serviceCharge) > 0) {
            lineItems.push(this.getLineItem('Service', parseFloat(shippingServiceCharges.serviceCharge).toFixed(2)));
        }

        let totalRegulatoryFee = 0;
        if (isDetailShippingEnabled && stateDeliveryFeeEnabled) {
            totalRegulatoryFee = Number(this.cartData?.detailShippingCharges?.shippingCharge?.regulatoryFee || 0)
                    + Number(this.cartData?.detailShippingCharges?.serviceCharge?.regulatoryFee || 0);

            if (totalRegulatoryFee > 0) {
                lineItems.push(this.getLineItem('Regulatory Fees', totalRegulatoryFee));
            }
        }

        if (this.cartData?.appliedPromotions?.length > 0) {
            lineItems.push(this.getLineItem('Promotion', parseFloat(this.cartData.totalDiscount).toFixed(2)));
        }

        lineItems.push(this.getLineItem('Tax', typeof this.tax === 'number' ? this.tax.toFixed(2) : this.tax));
        this.total = Number(this.cartData?.cartTotal);

        return lineItems;
    };

    // getLineItemsCoupon = (cartData) => {
    //     this.price = cartData.totalProduct;
    //     this.shipping = cartData.totalShippingMap.shippingCharge;
    //     this.service = cartData.totalShippingMap.serviceCharge;
    //     this.tax = cartData.totalTax;

    //     const lineItems = [
    //         this.getLineItem('Item Price', typeof this.price === 'number' ? this.price.toFixed(2) : this.price),
    //     ];

    //     if (parseFloat(this.shipping) > 0) {
    //         lineItems.push(this.getLineItem('Shipping', parseFloat(this.shipping).toFixed(2)));
    //     }

    //     if (parseFloat(this.service) > 0) {
    //         lineItems.push(this.getLineItem('Service', parseFloat(this.service).toFixed(2)));
    //     }

    //     if (cartData?.appliedPromotions?.length > 0) {
    //         cartData.appliedPromotions.forEach(
    //             (promotion) => lineItems.push(this.getLineItem('Promotion', parseFloat(promotion.appliedAmount).toFixed(2))),
    //         );
    //     }

    //     lineItems.push(this.getLineItem('Tax', typeof this.tax === 'number' ? this.tax.toFixed(2) : this.tax));

    //     this.total = Number(this.price) + Number(this.shipping) + Number(this.tax);

    //     return lineItems;
    // };

    getCarData = async (cartOrderId) => {
        const { auth, saveCartData } = this.props;
        const jwtToken = await auth.getAccessTokenSafely();

        const cartResponse = await cartServices.getCartOrderDetails({
            wcEnv: {},
            jwtToken,
            cartId: cartOrderId,
        });

        const { data } = cartResponse;
        saveCartData(data);

        return data;
    };

    addItemToCart = async () => {
        const {
            auth, selectedSku, setOrderId, brand, giftMessage,
        } = this.props;

        const jwtToken = await auth.getAccessTokenSafely();

        let productCode = selectedSku?.id;
        if (productCode?.indexOf('-') >= 0) {
            productCode = productCode.split('-');
            productCode = productCode[productCode.length - 1];
        }

        const product = {
            brandCode: brand?.id,
            productCode,
            quantity: 1,
        };

        if (selectedSku?.priceRules?.length) {
            product.priceRules = selectedSku.priceRules;
        }

        // gift message
        if (giftMessage && giftMessage.message && giftMessage.message !== ''
        ) {
            product.greeting = {
                message: giftMessage.message,
                occasionCode: '',
                signature: '',
            };
        }

        const addToCartResp = await cartServices.addToCart({
            env: {},
            jwtToken,
            products: [product],
        });

        setOrderId([addToCartResp.data.cartId]);
        const data = await this.getCarData(addToCartResp.data.cartId);
        return data;
    }

    getDynamicPrice = async () => {
        const {
            enterpriseId,
            selectedSku: { id, prices },
            featureFlags,
            userSubmittedZip,
            flags,
        } = this.props;

        this.setState({
            cartEmpty: false,
        });
        const payload = {
            enterpriseId,
            products: [
                {
                    partNumber: id,
                },
            ],
            variants: [],
        };

        if (featureFlags['is-zip-dynamic-pricing-enabled'] && flags.zipDynamicPricingTest) {
            payload.variants.push({
                name: 'ZIP_CODE',
                value: userSubmittedZip,
            });
        }

        getPriceFromEngine({}, null, payload, featureFlags['is-price-engine-batching-enabled'])
            .then(({ data }) => {
                const price = data?.products?.[0]?.prices?.find((sku) => sku.type === 'sale')?.value;
                this.price = price;
            })
            .catch((ex) => {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    jsError: ex,
                    message: `GraphqlApplePay: fetch prices failed...${  ex.message}`,
                    enterpriseId,
                    partNumber: id,
                });
                const price = prices.find((sku) => sku.type === 'sale').value;
                this.price = price;
            })
            .finally(() => {
                this.setState({
                    cartEmpty: true,
                });
            });
    }

    createInitialPaymentRequest = () => {
        const {
            brand,
            selectedSku: { prices },
        } = this.props;

        if (!this.price) {
            const price = prices.find((sku) => sku.type === 'sale').value;
            this.price = price;
        }
        const paymentRequest = {
            currencyCode: 'USD',
            countryCode: 'US',
            requiredShippingContactFields: ['postalAddress', 'email', 'phone', 'name'],
            requiredBillingContactFields: ['postalAddress', 'phone'],
            total: { label: `${brand['display-name']}`, amount: this.price },
            supportedNetworks: ['amex', 'discover', 'masterCard', 'visa'],
            merchantCapabilities: ['supports3DS'],
        };

        // if (featureFlags['is-checkout-experimental-code-enabled']) {
        //     paymentRequest.supportsCouponCode = true;
        //     paymentRequest.couponCode = '';
        // }

        return paymentRequest;
    };

    getFirstOfTheMonth = () => {
        const today = new Date();
        // Need to add 1 to the month because javascript months are 0 indexed (jan is 0)
        // But backend is not 0 indexed (jan is 1)

        const month = this.shortMonthName[today.getMonth()];
        return `1-${month}-${(today.getFullYear() - 2000)}`;
    }

    generateNewShippingMethods = async (calendarDates) => {
        const { auth, featureFlags } = this.props;

        const surchargeEnabled = featureFlags['is-applepay-shipping-total-enabled'];

        const jwtToken = await auth.getAccessTokenSafely();
        // Getting the first date without surcharges or flex charge
        let deliveryDateInfo;
        for (let i = 0; i < calendarDates.length; i += 1) {
            if (
                (Number(calendarDates[i].surcharge) === 0 || Number(calendarDates[i].totSurcharge) === 0)
                && (!calendarDates[i].flexDetails || Number(calendarDates[i].flexDetails?.options?.[0]?.flexAmount) === 0)
            ) {
                deliveryDateInfo = applePayDateConverter(
                    [calendarDates[i]],
                    '0.00',
                    surchargeEnabled,
                )[0];
                break;
            }
        }

        const deliveryInfo = JSON.parse(deliveryDateInfo.identifier);
        const responseDeliveryDate = await cartServices.updateCartItemDeliveryInfo({
            env: {},
            jwtToken,
            cartId: this.cartId,
            cartItemId: this.orderItemId,
            ...deliveryInfo,
        });
        let newShippingMethods = [];
        if (responseDeliveryDate.data.result === 'SUCCESS') {
            const cartData = await cartServices.getCartOrderDetails({
                wcEnv: {},
                jwtToken,
                cartId: this.cartId,
            });

            if (cartData.data?.detailedShipping) {
                const baseShipping =  cartData.data.detailedShipping.serviceCharge?.baseCharges
                || cartData.data.detailedShipping.shippingCharge?.baseCharges || 0.00;

                newShippingMethods = applePayDateConverter(
                    calendarDates,
                    baseShipping,
                    surchargeEnabled,
                );
            }
        }

        return newShippingMethods;
    }

    getRecipientObj = (appleRecipient) => {
        let country = appleRecipient.countryCode;
        if (appleRecipient.countryCode === 'US') {
            country = 'USA';
        } else if (appleRecipient.countryCode === 'CA') {
            country = 'CAN';
        }

        return ({
            addressId: '',
            firstName: appleRecipient.givenName || 'flowers',
            lastName: appleRecipient.familyName || 'flowers',
            address1: appleRecipient.addressLines?.[0] || 'flowers',
            locationType: 'Residence',
            state: appleRecipient.administrativeArea,
            country,
            zipCode: appleRecipient.postalCode,
            city: appleRecipient.locality,
            phoneNumber: appleRecipient.phoneNumber || '0000000000',
            skipAddressBookAdd: true,
            addressStatus: 'O',
            isAddressVerified: false,
            dpvIndicator: 'N',
        });
    };

    handlePDPButtonClick = async () => {
        const {
            auth, callTrackEvent, clearCart, brand, history, actionGetCart, featureFlags,
            finishApplePay, flags,
            passportInCart, isPassportUser, isUserLoggedIn,
        } = this.props;

        const jwtToken = await auth.getAccessTokenSafely();

        const initialPaymentRequest = this.createInitialPaymentRequest();

        const session = new window.ApplePaySession(1, initialPaymentRequest);
        session.onvalidatemerchant = async (event) => {
            const merchantValData = {
                displayName: `${brand['display-name']}`,
                domainName: `${window.location.host}`,
                merchantIdentifier: `${mbpUtil.getEnv('APP_APPLE_PAY_MID')}`,
                validationURL: event.validationURL,
            };
            this.cartData = await this.addItemToCart();

            this.orderItemId = this.cartData.recipients[0].cartItems[0].cartItemId;
            this.cartId = this.cartData.cartId;

            const detailedShipping =  this.cartData.detailedShipping || {};
            this.shipping = detailedShipping.shippingCharge?.shippingChargesWithoutRegulatoryFee || 0;
            this.service = detailedShipping.serviceCharge?.serviceChargesWithoutRegulatoryFee || 0;
            this.detailedShipping = detailedShipping || {};
            this.tax = this.cartData.detailedTaxes?.taxesWithoutRegulatoryFee;
            this.total = Number(this.cartData.cartTotal);

            cartServices.getApplePayMerchantId({
                env: {},
                jwtToken,
                data: merchantValData,
            })
                .then((merchantSession) => {
                    session.completeMerchantValidation(merchantSession.data);
                })
                .catch((er) => {
                    console.log('Debug - error', er);
                    clearCart(this.orderItemId);
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay onvalidatemerchant',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        message: 'on merchant validate API call failed',
                    });
                });
        };

        session.onshippingcontactselected = async (event) => {
            this.applePayResponse.shippingContact = event.shippingContact;

            const recipient = this.getRecipientObj(event.shippingContact);

            // Save Recipient Address
            cartServices.saveRecipient({
                env: {},
                jwtToken,
                cartId: this.cartId,
                cartItemId: this.orderItemId,
                recipient,
            })
                .then(() => {
                    cartServices.getCartOrderDetails({
                        wcEnv: {},
                        jwtToken,
                        cartId: this.cartId,
                    }).then((cartResponse) => {
                        this.cartData = cartResponse?.data || {};

                        const cartItemInfo = this.cartData.recipients?.[0].cartItems?.[0] || {};
                        const startDate = this.getFirstOfTheMonth();

                        const brandCode = cartItemInfo.product?.brandCode;
                        const locationType = cartItemInfo.deliveryInfo?.locationType || 'Residence';
                        const zipCode = cartItemInfo.deliveryInfo?.zipCode || 'Residence';
                        const flexVersion = featureFlags['is-new-flex-flows-enabled'];

                        let productCode = cartItemInfo.product?.productCode;
                        if (productCode?.indexOf('-') >= 0) {
                            productCode = productCode.split('-');
                            productCode = productCode[productCode.length - 1];
                        }

                        let customerType = isUserLoggedIn ? 'R' : 'G';
                        if (passportInCart || (isUserLoggedIn && isPassportUser)) {
                            customerType = 'P';
                        }

                        cartServices.availablityDeliveryCalendar({
                            env: {},
                            jwtToken,
                            brandCode,
                            productCode,
                            locationType,
                            zipCode,
                            startDate,
                            variantId: flexVersion ? 'flex2' : null,
                            customerType,
                        })
                            .then(async ({ data }) => {
                                const { calendarDates } = data.response;
                                const newShippingMethods = await this.generateNewShippingMethods(calendarDates);
                                this.applePayResponse.shippingMethod = newShippingMethods[0];
                                cartServices.calculateCart({
                                    wcEnv: {},
                                    jwtToken,
                                    cartId: this.cartId,
                                }).then(() => {
                                    cartServices.getCartOrderDetails({
                                        wcEnv: {},
                                        jwtToken,
                                        cartId: this.cartId,
                                    }).then(async (cartInfo) => {
                                        this.cartData = cartInfo?.data || {};
                                        const detailedShipping =  this.cartData.detailedShipping || {};
                                        this.shipping = detailedShipping.shippingCharge?.shippingChargesWithoutRegulatoryFee || 0;
                                        this.service = detailedShipping.serviceCharge?.serviceChargesWithoutRegulatoryFee || 0;
                                        this.detailedShipping = detailedShipping || {};
                                        this.tax = this.cartData.detailedTaxes?.taxesWithoutRegulatoryFee;
                                        this.total = Number(this.cartData.cartTotal);
                                        const lineItems = this.getLineItems();
                                        const status = window.ApplePaySession.STATUS_SUCCESS;

                                        session.completeShippingContactSelection(
                                            status,
                                            newShippingMethods,
                                            {
                                                label: `${brand['display-name']}`,
                                                amount: Number(this.total).toFixed(2),
                                                type: 'final',
                                            },
                                            lineItems,
                                        );
                                    });
                                });
                            })
                            .catch((er) => {
                                console.log('Debug - error calendar:', er);
                                mbpLogger.logError({
                                    function: 'Graphql Apple Pay onshippingcontactselected',
                                    appName: process.env.npm_package_name,
                                    module: 'mbp-pwa-ui',
                                    jsError: er,
                                    message: 'on shipping contact or delivery calendar API call failed',
                                });
                            });
                    });
                });
        };

        session.onshippingmethodselected = (event) => {
            this.applePayResponse.shippingMethod = event.shippingMethod;

            const deliveryInfo = JSON.parse(event.shippingMethod.identifier);

            cartServices.updateCartItemDeliveryInfo({
                env: {},
                jwtToken,
                cartId: this.cartId,
                cartItemId: this.orderItemId,
                calculateCartData: true,
                deliveryDateType: 'on',
                ...deliveryInfo,
            })
                .then(() => {
                    cartServices.calculateCart({
                        wcEnv: {},
                        jwtToken,
                        cartId: this.cartId,
                    }).then(() => {
                        cartServices.getCartOrderDetails({
                            wcEnv: {},
                            jwtToken,
                            cartId: this.cartId,
                        }).then(async (cartInfo) => {
                            this.cartData = cartInfo?.data || {};
                            this.shipping = cartInfo.data.shipping || 0;
                            this.service = cartInfo.data.service;
                            this.detailedShipping = cartInfo.data.detailedShipping || {};
                            this.tax = Number(cartInfo.data.detailedTaxes?.taxesWithoutRegulatoryFee) || 0;
                            this.total = Number(cartInfo.data.cartTotal) || 0;
                            const lineItems = this.getLineItems();
                            const status = window.ApplePaySession.STATUS_SUCCESS;

                            session.completeShippingMethodSelection(
                                status,
                                {
                                    label: `${brand['display-name']}`,
                                    amount: parseFloat(this.total).toFixed(2),
                                    type: 'final',
                                },
                                lineItems,
                            );
                        });
                    });
                })
                .catch((er) => {
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay onshippingmethodselected',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        message: 'on shipping method selected API call failed',
                    });
                });
        };

        // if (featureFlags['is-checkout-experimental-code-enabled']) {
        //     console.log('mbp-ui - try coupon for applepay');
        //     // Add a listener for the oncouponcodechanged event to the Apple Pay session.
        //     session.oncouponcodechanged = async (event) => {
        //         console.log('oncouponcodechanged in!');
        //         const promoCode = event.couponCode;

        //         // Process the coupon code.
        //         await orderClient.applyPromotion(
        //             {},
        //             jwtToken,
        //             this.cartId,
        //             promoCode,
        //             '',
        //             '',
        //             '',
        //             'ApplePay',
        //         )
        //             .then(async (response) => {
        //                 mbpLogger.logDebug({
        //                     function: 'couponcodechanged',
        //                     appName: process.env.npm_package_name,
        //                     module: 'mbp-pwa-ui',
        //                     message: 'Apple Pay - response promo code applied',
        //                     response,
        //                 });
        //                 actionGetCart(this.cartId);
        //                 // Call the Apple Pay session completion method for this event.
        //                 cartServices.getCartOrderDetails({ wcEnv: {}, jwtToken, cartId: this.cartId })
        //                     .then((responseCart) => {
        //                         if (responseCart?.data) {
        //                             const newLineItems = this.getLineItemsCoupon(responseCart.data);
        //                             const errors = window.ApplePaySession.STATUS_SUCCESS;

        //                             session.completeCouponCodeChange({
        //                                 newTotal: {
        //                                     label: `${brand['display-name']}`,
        //                                     amount: this.total.toFixed(2),
        //                                     type: 'final',
        //                                 },
        //                                 newLineItems,
        //                                 errors,
        //                             });
        //                         }
        //                     })
        //                     .catch((er) => {
        //                         mbpLogger.logError({
        //                             function: 'Apple Pay get cart data',
        //                             appName: process.env.npm_package_name,
        //                             module: 'mbp-pwa-ui',
        //                             jsError: er,
        //                             cartId: this.cartId,
        //                             message: 'getting cart data failed',
        //                         });
        //                     });
        //             })
        //             .catch((er) => {
        //                 mbpLogger.logError({
        //                     function: 'Apple Pay couponcodechanged',
        //                     appName: process.env.npm_package_name,
        //                     module: 'mbp-pwa-ui',
        //                     jsError: er,
        //                     cartId: this.cartId,
        //                     message: 'save promo call failed',
        //                 });
        //                 console.log('catch - applepay session', session);
        //                 console.log('catch - window.ApplePaySession', window.ApplePaySession);
        //                 let errorCode = 'couponCodeInvalid';
        //                 let errorMessage = er.response.data?.detailedError?.errorMessage || 'Invalid Coupon Code';

        //                 if (er.response.data?.detailedError?.errorKey?.indexOf('has expired') > 0) {
        //                     errorCode = 'couponCodeExpired';
        //                     errorMessage = er.response.data?.detailedError.errorMessage;
        //                 }

        //                 // Call the Apple Pay session completion method for this event.
        //                 const newLineItems = this.getLineItems();
        //                 // const status = window.ApplePaySession.STATUS_FAILURE;
        //                 console.log('errorCode', errorCode);
        //                 const inValidCouponError = new window.ApplePayError('couponCodeInvalid', '', errorMessage);

        //                 session.completeCouponCodeChange({
        //                     newTotal: {
        //                         label: `${brand['display-name']}`,
        //                         amount: this.total.toFixed(2),
        //                         type: 'final',
        //                     },
        //                     newLineItems,
        //                     error: inValidCouponError,
        //                 });
        //                 console.log('session - after', session, errorMessage);
        //             });
        //     };
        // }

        session.onpaymentmethodselected = (event) => {
            this.applePayResponse.paymentMethod = event.paymentMethod;

            cartServices.initPayment({
                env: {},
                jwtToken,
                cartId: this.cartId,
                paymentMethod: 'ApplePay',
            })
                .then(() => {
                    const lineItems = this.getLineItems();

                    session.completePaymentMethodSelection(
                        {
                            label: `${brand['display-name']}`,
                            amount: this.total.toFixed(2),
                            type: 'final',
                        },
                        lineItems,
                    );
                })
                .catch((er) => {
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay onpaymentmethodselected',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        message: 'on payment selected API call failed',
                    });
                });
        };

        session.onpaymentauthorized = async (event) => {
            this.applePayResponse.payment = event.payment;

            const billingContact = event.payment?.billingContact || {};
            const shippingContact = event.payment?.shippingContact || {};

            if (event.payment?.shippingContact?.phoneNumber) {
                billingContact.phoneNumber = event.payment?.shippingContact?.phoneNumber;
                shippingContact.phoneNumber = event.payment?.shippingContact?.phoneNumber;
            }

            const billingAddress = this.getRecipientObj(billingContact || {});
            const recipient = this.getRecipientObj(shippingContact || {});

            if (event.payment?.shippingContact?.emailAddress) {
                billingAddress.email = event.payment?.shippingContact?.emailAddress;
                billingAddress.confirmEmail = event.payment?.shippingContact?.emailAddress;
            }

            const paymentData = event.payment?.token || {};

            const analyticsSession = getAnalyticsStorageData();
            const attributes = [];

            // Adding extra attribute from campaing
            if (analyticsSession?.landingParams?.u1) {
                attributes.push(
                    {
                        attributeName: 'bgsu1',
                        attributeValue: analyticsSession.landingParams.u1,
                    },
                );

                cartServices.updateAttribute({
                    cartId: this.cartId,
                    jwtToken,
                    attributes,
                }).catch((er) => {
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay Attribution on PDP',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        errorMessage: {
                            cartId: this.cartId,
                            attributes: JSON.stringify(attributes),
                        },
                        message: 'Place Apple Pay Order attribute bgsu1 failed',
                    });
                });
            }

            const cookies = new Cookies();
            const bannerObj = cookies.get('banner');
            let bannerCode = bannerObj?.c;

            if ((!bannerCode || bannerCode === 'null') && analyticsSession?.landingParams?.r) {
                bannerCode = analyticsSession?.landingParams?.r;
            }

            if (bannerCode) {
                cartServices.recordAttributions({
                    jwtToken,
                    cartId: this.cartId,
                    bannerCode,
                }).catch((er) => {
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay Attribution on PDP',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        errorMessage: {
                            cartId: this.cartId,
                            bannerCode,
                        },
                        message: 'Place Apple Pay API record attribution failed',
                    });
                });
            }

            // Save Recipient Address
            cartServices.saveRecipient({
                env: {},
                jwtToken,
                cartId: this.cartId,
                cartItemId: this.orderItemId,
                recipient,
            })
                .then(() => {
                    cartServices.placeOrderCart({
                        env: {},
                        jwtToken,
                        cartId: this.cartId,
                        sourceApp: 'PWA',
                        customer: {
                            billingAddress,
                        },
                        payment: {
                            paymentMethod: 'ApplePay',
                            accountNumber: event.payment.token?.paymentData?.data,
                            brand: paymentData.paymentMethod?.network,
                            applePay: {
                                ...event.payment.token?.paymentData?.header,
                                signature: event.payment.token?.paymentData?.signature,
                                version: event.payment.token?.paymentData?.version,
                            },
                        },
                    })
                        .then(() => {
                            const status = window.ApplePaySession.STATUS_SUCCESS;
                            session.completePayment(status);

                            // We need send the email to the enterpriseId.
                            const email = billingAddress?.email || '';

                            finishApplePay(history, email);
                        })
                        .catch((er) => {
                            mbpLogger.logError({
                                function: 'Graphql Apple Pay placeOrderApplePay',
                                appName: process.env.npm_package_name,
                                module: 'mbp-pwa-ui',
                                jsError: er,
                                cartId: this.cartId,
                                message: 'on payment authorized API call failed',
                            });
                        });
                })
                .catch((er) => {
                    mbpLogger.logError({
                        function: 'Graphql Apple Pay saveRecipient',
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        jsError: er,
                        event,
                        objectSend: {
                            cartId: this.cartId,
                            orderItemId: this.orderItemId,
                            orderTotal: this.total.toFixed(2),
                            response: JSON.stringify(this.applePayResponse),
                            reviewPage: false,
                        },
                        message: 'on save recipient API call failed',
                    });
                });
        };

        session.oncancel = () => {
            if (Number(this.cartData?.orderSize || 0) > 0) {
                cartServices.removeOrderItem({
                    env: this.wcEnv,
                    jwtToken,
                    orderItemId: this.orderItemId,
                    cartId: this.cartId,
                })
                    .then(() => {
                        actionGetCart([this.cartId]);
                        if (!flags?.shippingDynamicPricingTest && !this.dynamicPriceTest()) {
                            this.price = '';
                        }
                        this.shipping = '';
                        this.service = '';
                        this.detailedShipping = null;
                        this.tax = '';
                        this.total = 0;
                        this.orderItemId = '';
                        this.cartId = '';
                        this.cartData = {};
                        this.applePayResponse = {};
                    })
                    .catch((er) => {
                        mbpLogger.logError({
                            function: 'Graphql Apple Pay oncancel',
                            appName: process.env.npm_package_name,
                            module: 'mbp-pwa-ui',
                            jsError: er,
                            message: 'on cancel API call failed',
                        });
                        actionGetCart([this.cartId]);
                    });
            } else {
                actionGetCart(['']);
                if (!flags?.shippingDynamicPricingTest && !flags?.dynamicPricingTest) {
                    this.price = '';
                }
                this.shipping = '';
                this.service = '';
                this.detailedShipping = null;
                this.tax = '';
                this.total = 0;
                this.orderItemId = '';
                this.cartId = '';
                this.cartData = {};
                this.applePayResponse = {};
            }
        };
        session.begin();

        callTrackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Feature Interaction',
            eventLabel: 'Apple Pay on PDP',
        });
    };

    getTextTermsCopy = () => (
        <Grid item container direction="column">
            <Typography style={
                {
                    color: '#000',
                    fontSize: '0.8em',
                    lineHeight: '1.1em',
                    margin: '10px 0 15px',
                    width: '100%',
                    textAlign: 'center',
                }
            }
            >
                By tapping or clicking the Apple Pay button, I agree to be bound by the <a target="_blank" rel="noopener noreferrer" href="/About-Us-Terms-of-Use" aria-label="terms-of-use">Terms of Use</a> and <a target="_blank" rel="noopener noreferrer" href="/About-Us-Privacy-Policy" aria-label="privacy">Privacy Notice.</a>
            </Typography>
        </Grid>
    );

    render() {
        const { cartEmpty } = this.state;
        const { applePayEnabled } = this.props;
        // Do not allow apple pay if there is already item in cart.

        if (applePayEnabled === 1 && cartEmpty === true) {
            return (
                <Grid container direction="column">
                    {/* Styles are inlined in this component because few are needed and to avoid HoC wrapping */}
                    <Grid item style={{ textAlign: 'center' }}>Or</Grid>
                    <div
                        style={{
                            display: 'inline-block',
                            '-webkit-appearance': '-apple-pay-button',
                            '-apple-pay-button-style': 'black',
                            '-apple-pay-button-type': 'buy',
                            height: '40px',
                            width: '100%',
                        }}
                        onClick={this.handlePDPButtonClick}
                        onKeyDown={this.handlePDPButtonClick}
                        role="link"
                        tabIndex={0}
                        id="applePayButtonID"
                        aria-label="apple pay button"
                    />
                    {this.getTextTermsCopy()}
                </Grid>
            );
        }
        return null;
    }
}

const mapStateToProps = (state) => ({
    applePayEnabled: getApplePayStatus(state),
    // appliedPromos: getAppliedPromotions(state),
    brand: getBrand(state),
    enterpriseId: getEnterpriseId(state),
    featureFlags: getFeatureFlags(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    isUserLoggedIn: getIsAuthenticatedStatus(state),
    passportInCart: getPassportSubscriptionStatus(state),
    noOfItemsInCart: getTotalItemInCart(state),
    userSubmittedZip: getUserSubmittedProductFilterZipcode(state),
});

const mapDispatchToProps = (dispatch) => ({
    callTrackEvent: bindActionCreators(trackEvent, dispatch),
    clearCart: bindActionCreators(deleteItem, dispatch),
    saveCartData: bindActionCreators(loadCart, dispatch),
    checkApplePay: bindActionCreators(checkApplePayEnabled, dispatch),
    setOrderId: bindActionCreators(loadOrderId, dispatch),
    actionGetCart: bindActionCreators(getCart, dispatch),
    finishApplePay: bindActionCreators(applePayOrderSuccess, dispatch),
});

GraphqlApplePay.propTypes = {
    callTrackEvent: func.isRequired,
    clearCart: func.isRequired,
    featureFlags: object.isRequired,
    finishApplePay: func.isRequired,
    saveCartData: func.isRequired,
    actionGetCart: func.isRequired,
    brand: object.isRequired,
    history: object.isRequired,
    flags: object,
    passportInCart: object.isRequired,
    isPassportUser: bool.isRequired,
    isUserLoggedIn: bool.isRequired,
    userSubmittedZip: string,
    enterpriseId: string,
    selectedSku: shape({
        __typename: string,
        id: string,
        name: string,
        ageVerifyFlag: string,
        minAge: string,
        prices: arrayOf(
            shape({
                type: string,
                value: number,
                __typename: string,
            }),
        ),
    }),
    applePayEnabled: number.isRequired,
    checkApplePay: func.isRequired,
    noOfItemsInCart: number,
    setOrderId: func.isRequired,
    giftMessage: string,
    // appliedPromos: shape({
    //     appliedPromotions: shape({
    //         appliedAmount: string,
    //     }),
    // }).isRequired,
    auth: shape({
        getAccessTokenSafely: func.isRequired,
    }).isRequired,
};

GraphqlApplePay.defaultProps = {
    selectedSku: {},
    giftMessage: '',
    noOfItemsInCart: 0,
    enterpriseId: '',
    userSubmittedZip: '',
    flags: {},
};

export default compose(
    withLDConsumer(),
    withAuth,
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(GraphqlApplePay);
